import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Laŭ bosko ĉeriza, <br/>
        Laŭ bosko meriza, <br/>
        Por naskiĝtag’ de l’ amik’ <br/>
        Paŝadis en paco <br/>
        Sur pad’ erinaco <br/>
        Kun la flutet’ en manik’.
      </p>

      <p class="poem-block mb-3">
        Sunon rigardis li, <br/>
        Floretojn gardis li, <br/>
        Treti ne volis dum voj’, <br/>
        La kokcinelojn, <br/>
        La fungajn ombrelojn <br/>
        Li kore salutis kun ĝoj’.
      </p>

      <p class="poem-block mb-3">
        Pinglaj abioj! <br/>
        Pro kio kun krioj <br/>
        Kuras pikita vulpid’? <br/>
        Inter amikoj <br/>
        Sen artifikoj <br/>
        Ekregu nur am’ kaj konfid’!
      </p>

      <p class="poem-block mb-3">
        Bluas ĉielo nun, <br/>
        Sub varma hela sun’ <br/>
        Por naskiĝtag’ de l’ amik’ <br/>
        Fluton ludante <br/>
        Kaj piedfrapante <br/>
        Jen paŝis l’ etul’ tra erik’! (fajfado)
      </p>

      <p class="poem-block mb-3">
        Kara birdeto! <br/>
        Al vi estas peto: <br/>
        Flugu laŭ ruĝa montril’! <br/>
        Tie ĉe l’ bovo <br/>
        Atendas vin trovo: <br/>
        Plumo el via flugil’.
      </p>

      <p class="poem-block mb-3">
        Jen kun donaco <br/>
        Laŭ pad’ erinaco <br/>
        Paŝis al sia amik’. <br/>
        Sed kion li portis, <br/>
        Li nure raportis <br/>
        Al Vanjo per flut’ el manik’!
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Erinaco'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['tQVYSmiBWx8'],
    itemTranslator: `
      Teksto: Junna Moroz, <br/>
      Muziko: Sergej Nikitin kaj Tatjana Nikitina, <br/>
      ${translator.esp}
    `
  }
}

export default item;